import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import { Dimmer } from "../spinner";
import { validaSoloNumero, validaEmail } from "../../util/varios";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CatalogoAgente from "../../catalogos/catalogoAgente";
import { Mensaje, MensajeSiNo } from "../mensajes";

const ModalActualizarUsuario = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const chkPerCon = useRef();
  const chkPerIn = useRef();
  const chkPerMod = useRef();
  const chkPerEli = useRef();
  const chkPerTodo = useRef();

  const chkUsuCon = useRef();
  const chkUsuIn = useRef();
  const chkUsuMod = useRef();
  const chkUsuEli = useRef();
  const chkUsuTodo = useRef();

  const chkUCCon = useRef();
  const chkUCIn = useRef();
  const chkUCMod = useRef();
  const chkUCEli = useRef();
  const chkUCTodo = useRef();

  const chkUteCon = useRef();
  const chkUteIn = useRef();
  const chkUteMod = useRef();
  const chkUteEli = useRef();
  const chkUteTodo = useRef();

  const chkPorCon = useRef();
  const chkPorIn = useRef();
  const chkPorMod = useRef();
  const chkPorEli = useRef();
  const chkPorTodo = useRef();

  const chkUWebCon = useRef();
  const chkUWebIn = useRef();
  const chkUWebMod = useRef();
  const chkUWebEli = useRef();
  const chkUWebTodo = useRef();

  const chkUAppCon = useRef();
  const chkUAppIn = useRef();
  const chkUAppMod = useRef();
  const chkUAppEli = useRef();
  const chkUAppTodo = useRef();

  const chkOrgCon = useRef();
  const chkOrgIn = useRef();
  const chkOrgMod = useRef();
  const chkOrgEli = useRef();
  const chkOrgTodo = useRef();

  const btnCancela = useRef();
  const btnAcepta = useRef();

  //////// Tab 1 ///////////////////////
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const txtIdUsuario = useRef();
  const txtLogin = useRef();
  const txtPassword = useRef();
  const txtConfirmPassword = useRef();
  const txtIdAgente = useRef();
  const txtNombreAgente = useRef();
  const txtCedula = useRef();
  const txtNombreUsuario = useRef();
  const txtApellidoUsuario = useRef();
  const txtDireccionUsuario = useRef();
  const txtEmailUsuario = useRef();
  const txtTlfUsuario = useRef();
  const txtCelUsuario = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const cmbStatus = useRef();

  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  //////// Tab 1 ///////////////////////

  const [itemAccaplicaciones, setItemAccaplicaciones] = useState();
  const [itemAccconfigene, setItemAccconfigene] = useState();
  const [itemAccpersonas, setItemAccpersonas] = useState();
  const [itemAccusertim, setItemAccusertim] = useState();
  const [itemAccuc, setItemAccuc] = useState();
  const [itemAccute, setItemAccute] = useState();
  const [itemAccporcenute, setItemAccporcenute] = useState();
  const [itemAccuserweb, setItemAccuserweb] = useState();
  const [itemAccuserapp, setItemAccuserapp] = useState();
  const [itemAccestorg, setitemAccestorg] = useState();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [body, setBody] = useState({});
  const [activate, setActivate] = useState(false);

  const [modulos, setModulos] = useState({
    permodtimbre: "0",
    permodminas: "0",
    permod1x500: "0",
    permodprod: "0",
    permodfiscal: "0",
    permodingresos: "0",
    permodpresu: "0",
    permodconfig: "0",
    estadal: "0",
    rentas: "0",
    solvencia: "0",
    timbreelectronico: "0",
  });

  const [operacionesMod, setOperacionesMod] = useState({
    personas1: " ",
    personas2: " ",
    personas3: " ",
    personas4: " ",
    usuarios1: " ",
    usuarios2: " ",
    usuarios3: " ",
    usuarios4: " ",
    unidadcontable1: " ",
    unidadcontable2: " ",
    unidadcontable3: " ",
    unidadcontable4: " ",
    valorute1: " ",
    valorute2: " ",
    valorute3: " ",
    valorute4: " ",
    porcentaje1: " ",
    porcentaje2: " ",
    porcentaje3: " ",
    porcentaje4: " ",
    usuarioweb1: " ",
    usuarioweb2: " ",
    usuarioweb3: " ",
    usuarioweb4: " ",
    usuarioapp1: " ",
    usuarioapp2: " ",
    usuarioapp3: " ",
    usuarioapp4: " ",
    organizacion1: " ",
    organizacion2: " ",
    organizacion3: " ",
    organizacion4: " ",
  });
  const [modulosConfig, setModulosConfig] = useState({
    opcion1: "0",
    opcion2: "0",
    opcion3: "0",
    opcion4: "0",
    opcion5: "0",
    opcion6: "0",
    opcion7: "0",
    opcion8: "0",
    opcion9: "0",
    opcion10: "0",
  });

  const procesarRegistro = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarusuariotimbre/${operacion}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRender();

          let mensaje = "";
          if (operacion === 1) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido registrada de manera satisfactoria.";
          } else if (operacion === 2) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido modificada de manera satisfactoria.";
          } else if (operacion === 3) {
            mensaje =
              "El usuario " +
              response.data.iduser +
              " ha sido eliminada de manera satisfactoria.";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: mensaje,
            icono: "exito",
          });
          blanquear();

          if (idusuario === parseInt(props.usuario.idusuario)) {
            localStorage.setItem(
              "permisos",
              JSON.stringify(itemAccaplicaciones)
            );
            localStorage.setItem(
              "accconfigene",
              JSON.stringify(itemAccconfigene)
            );
            localStorage.setItem(
              "accpersonas",
              JSON.stringify(itemAccpersonas)
            );
            localStorage.setItem("accusertim", JSON.stringify(itemAccusertim));
            localStorage.setItem("accuc", JSON.stringify(itemAccuc));
            localStorage.setItem("accute", JSON.stringify(itemAccute));
            localStorage.setItem(
              "accporcenute",
              JSON.stringify(itemAccporcenute)
            );
            localStorage.setItem("accuserweb", JSON.stringify(itemAccuserweb));
            localStorage.setItem("accuserapp", JSON.stringify(itemAccuserapp));
            localStorage.setItem("accestorg", JSON.stringify(itemAccestorg));
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreUsuario.current.value = "";
            txtApellidoUsuario.current.value = "";
            txtDireccionUsuario.current.value = "";
            txtEmailUsuario.current.value = "";
            txtTlfUsuario.current.value = "";
            txtCelUsuario.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreUsuario.current.value = response.data.nombres;
            txtApellidoUsuario.current.value = response.data.apellidos;
            txtDireccionUsuario.current.value = response.data.direccion;
            txtEmailUsuario.current.value = response.data.correoe;
            txtTlfUsuario.current.value = response.data.tlf1;
            txtCelUsuario.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreUsuario.current.focus();
              }, 100);
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreUsuario.current.value = nomPer;
    txtApellidoUsuario.current.value = apePer;
    txtDireccionUsuario.current.value = direPer;
    txtEmailUsuario.current.value = correoPer;
    txtTlfUsuario.current.value = tlf1Per;
    txtCelUsuario.current.value = tlf2Per;
    txtFechaNac.current.value = moment(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaCatalogoAge = (idAge, nomAge) => {
    setMostrar4(false);
    txtIdAgente.current.value = idAge;
    txtNombreAgente.current.value = nomAge;
    txtCedula.current.focus();
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoAge = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const blanquear = () => {
    setActivate(false);
    setOperacionPer(0);
    setModulos({
      permodtimbre: "0",
      permodminas: "0",
      permod1x500: "0",
      permodprod: "0",
      permodfiscal: "0",
      permodingresos: "0",
      permodpresu: "0",
      permodconfig: "0",
      estadal: "0",
      rentas: "0",
      solvencia: "0",
    });
    setModulosConfig({
      opcion1: "0",
      opcion2: "0",
      opcion3: "0",
      opcion4: "0",
      opcion5: "0",
      opcion6: "0",
      opcion7: "0",
      opcion8: "0",
      opcion9: "0",
      opcion10: "0",
    });

    setOperacionesMod({
      personas1: " ",
      personas2: " ",
      personas3: " ",
      personas4: " ",
      usuarios1: " ",
      usuarios2: " ",
      usuarios3: " ",
      usuarios4: " ",
      unidadcontable1: " ",
      unidadcontable2: " ",
      unidadcontable3: " ",
      unidadcontable4: " ",
      valorute1: " ",
      valorute2: " ",
      valorute3: " ",
      valorute4: " ",
      porcentaje1: " ",
      porcentaje2: " ",
      porcentaje3: " ",
      porcentaje4: " ",
      usuarioweb1: " ",
      usuarioweb2: " ",
      usuarioweb3: " ",
      usuarioweb4: " ",
      usuarioapp1: " ",
      usuarioapp2: " ",
      usuarioapp3: " ",
      usuarioapp4: " ",
      organizacion1: " ",
      organizacion2: " ",
      organizacion3: " ",
      organizacion4: " ",
    });

    setItemAccaplicaciones("");
    setItemAccconfigene("");
    setItemAccpersonas("");
    setItemAccusertim("");
    setItemAccuc("");
    setItemAccute("");
    setItemAccporcenute("");
    setItemAccuserweb("");
    setItemAccuserapp("");
    setitemAccestorg("");
  };

  const handleChangeOtro = (event) => {
    setModulos({
      ...modulos,
      [event.target.name]: event.target.value === "true" ? "1" : "0",
    });
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCodigo") {
        txtLogin.current.focus();
      } else if (event.target.id === "inputLogin") {
        txtPassword.current.focus();
      } else if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtPassword.current.focus();
        } else {
          txtConfirmPassword.current.focus();
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
          txtConfirmPassword.current.focus();
        } else {
          txtIdAgente.current.focus();
        }
      } else if (event.target.id === "inputNomUsuario") {
        txtApellidoUsuario.current.focus();
      } else if (event.target.id === "inputApeUsuario") {
        txtDireccionUsuario.current.focus();
      } else if (event.target.id === "inputDireUsuario") {
        txtEmailUsuario.current.focus();
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputConfirmPassword") {
        if (
          txtConfirmPassword.current.value !== "" &&
          txtPassword.current.value !== txtConfirmPassword.current.value
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Las Contraseñas no coinciden.",
            icono: "informacion",
          });
        }
      } else if (event.target.id === "inputEmailUsuario") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfUsuario.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfUsuario.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfUsuario") {
        txtCelUsuario.current.focus();
      } else if (event.target.id === "inputCelUsuario") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosAgente(event.target.value);
      } else {
        txtNombreUsuario.current.value = "";
      }
    }
  };

  const datosAgente = (idagente) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idagente}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtNombreAgente.current.value = response.data.nombre;
            txtCedula.current.focus();
          } else {
            txtNombreAgente.current.value = "";
            txtIdAgente.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Agente no existe.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    var sigue = true;
    var mensaje = "";
    let personas = "";
    let usuarios = "";
    let contable = "";
    let ute = "0000";
    let porcentaje = "";
    let userweb = "";
    let userapp = "";
    let org = "";

    if (modulosConfig.opcion2 === "1") {
      let permiso1 = chkPerCon.current.checked === true ? "1" : "0";
      let permiso2 = chkPerIn.current.checked === true ? "1" : "0";
      let permiso3 = chkPerMod.current.checked === true ? "1" : "0";
      let permiso4 = chkPerEli.current.checked === true ? "1" : "0";

      personas = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      personas = "0000";
    }

    if (modulosConfig.opcion3 === "1") {
      let permiso1 = chkUsuCon.current.checked === true ? "1" : "0";
      let permiso2 = chkUsuIn.current.checked === true ? "1" : "0";
      let permiso3 = chkUsuMod.current.checked === true ? "1" : "0";
      let permiso4 = chkUsuEli.current.checked === true ? "1" : "0";

      usuarios = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      usuarios = "0000";
    }

    if (modulosConfig.opcion4 === "1") {
      let permiso1 = chkUCCon.current.checked === true ? "1" : "0";
      let permiso2 = chkUCIn.current.checked === true ? "1" : "0";
      let permiso3 = chkUCMod.current.checked === true ? "1" : "0";
      let permiso4 = chkUCEli.current.checked === true ? "1" : "0";

      contable = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      contable = "0000";
    }

    /* if(modulosConfig.opcion5 === '1'){

            let permiso1 = chkUteCon.current.checked === true ? '1' : '0';
            let permiso2 = chkUteIn.current.checked === true ? '1' : '0';
            let permiso3 = chkUteMod.current.checked === true ? '1' : '0';
            let permiso4 = chkUteEli.current.checked === true ? '1' : '0';

            ute = permiso1+permiso2+permiso3+permiso4
        } else{

            ute = '0000'

        }
 */
    if (modulosConfig.opcion6 === "1") {
      let permiso1 = chkPorCon.current.checked === true ? "1" : "0";
      let permiso2 = chkPorIn.current.checked === true ? "1" : "0";
      let permiso3 = chkPorMod.current.checked === true ? "1" : "0";
      let permiso4 = chkPorEli.current.checked === true ? "1" : "0";

      porcentaje = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      porcentaje = "0000";
    }

    if (modulosConfig.opcion7 === "1") {
      let permiso1 = chkUWebCon.current.checked === true ? "1" : "0";
      let permiso2 = chkUWebIn.current.checked === true ? "1" : "0";
      let permiso3 = chkUWebMod.current.checked === true ? "1" : "0";
      let permiso4 = chkUWebEli.current.checked === true ? "1" : "0";

      userweb = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      userweb = "0000";
    }

    if (modulosConfig.opcion8 === "1") {
      let permiso1 = chkUAppCon.current.checked === true ? "1" : "0";
      let permiso2 = chkUAppIn.current.checked === true ? "1" : "0";
      let permiso3 = chkUAppMod.current.checked === true ? "1" : "0";
      let permiso4 = chkUAppEli.current.checked === true ? "1" : "0";

      userapp = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      userapp = "0000";
    }

    if (modulosConfig.opcion9 === "1") {
      let permiso1 = chkOrgCon.current.checked === true ? "1" : "0";
      let permiso2 = chkOrgIn.current.checked === true ? "1" : "0";
      let permiso3 = chkOrgMod.current.checked === true ? "1" : "0";
      let permiso4 = chkOrgEli.current.checked === true ? "1" : "0";

      org = permiso1 + permiso2 + permiso3 + permiso4;
    } else {
      org = "0000";
    }

    if (txtLogin.current.value.trim() === "") {
      mensaje = "El Usuario no debe estar vacio";
      sigue = false;

      txtLogin.current.focus();
    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
      mensaje = "La Contraseña no debe estar vacia";
      sigue = false;

      txtPassword.current.focus();
    } else if (
      txtConfirmPassword.current.value.trim() === "" &&
      operacion === 1
    ) {
      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
      sigue = false;

      txtConfirmPassword.current.focus();
    } else if (
      txtPassword.current.value.trim() !==
        txtConfirmPassword.current.value.trim() &&
      operacion === 1
    ) {
      mensaje = "Las Contraseñas no coinciden";
      sigue = false;

      txtConfirmPassword.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreUsuario.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      txtNombreUsuario.current.focus();
    } else if (txtApellidoUsuario.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      txtApellidoUsuario.current.focus();
    } else if (txtDireccionUsuario.current.value.trim() === "") {
      mensaje = "La direccion del Usuario no debe estar vacia";
      sigue = false;
      txtDireccionUsuario.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      txtFechaNac.current.focus();
    } else if (
      modulosConfig.opcion2 === "1" &&
      !chkPerCon.current.checked &&
      !chkPerIn.current.checked &&
      !chkPerMod.current.checked &&
      !chkPerEli.current.checked
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones validas para le modulo Personas";
      sigue = false;
      chkPerTodo.current.focus();
    } else if (
      modulosConfig.opcion3 === "1" &&
      !chkUsuCon.current.checked &&
      !chkUsuIn.current.checked &&
      !chkUsuMod.current.checked &&
      !chkUsuEli.current.checked
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones validas para le modulo Usuarios";
      sigue = false;
      chkUsuTodo.current.focus();
    } else if (
      modulosConfig.opcion4 === "1" &&
      !chkUCCon.current.checked &&
      !chkUCIn.current.checked &&
      !chkUCMod.current.checked &&
      !chkUCEli.current.checked
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones validas para le modulo Unidad Contable";
      sigue = false;
      chkUCTodo.current.focus();
    } else if (
      /*   else if (modulosConfig.opcion5 === '1' && !chkUteCon.current.checked && !chkUteIn.current.checked && !chkUteMod.current.checked && !chkUteEli.current.checked ){
              mensaje = 'Debe Seleccionar las Operaciones validas para le modulo Valor UTE';
              sigue = false;
              chkUteTodo.current.focus()
          } 
   */
      modulosConfig.opcion6 === "1" &&
      !chkPorCon.current.checked &&
      !chkPorIn.current.checked &&
      !chkPorMod.current.checked &&
      !chkPorEli.current.checked
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones validas para le modulo Porcentaje UTE";
      sigue = false;
      chkPorTodo.current.focus();
    } else if (
      modulosConfig.opcion7 === "1" &&
      !chkUWebIn.current.checked &&
      !chkUWebMod.current.checked &&
      !chkUWebEli.current.checked
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones validas para le modulo Gestion de Usuario Web";
      sigue = false;
      chkUWebTodo.current.focus();
    } else if (
      modulosConfig.opcion8 === "1" &&
      !chkUAppCon.current.checked &&
      !chkUAppIn.current.checked &&
      !chkUAppMod.current.checked &&
      !chkUAppEli.current.checked
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones validas para le modulo Gestion de Usuario App";
      sigue = false;
      chkUAppTodo.current.focus();
    } else if (
      modulosConfig.opcion9 === "1" &&
      !chkOrgCon.current.checked &&
      !chkOrgIn.current.checked &&
      !chkOrgMod.current.checked &&
      !chkOrgEli.current.checked
    ) {
      mensaje =
        "Debe Seleccionar las Operaciones validas para le modulo Estructura Organizativa";
      sigue = false;
      chkOrgTodo.current.focus();
    }

    setItemAccaplicaciones(
      modulos.permodtimbre +
        modulos.permodminas +
        modulos.permod1x500 +
        modulos.permodprod +
        modulos.permodfiscal +
        modulos.permodingresos +
        modulos.permodpresu +
        modulos.permodconfig +
        modulos.rentas +
        modulos.estadal +
        modulos.solvencia +
        modulos.timbreelectronico
    );
    setItemAccconfigene(
      modulosConfig.opcion1 +
        modulosConfig.opcion2 +
        modulosConfig.opcion3 +
        modulosConfig.opcion4 +
        modulosConfig.opcion5 +
        modulosConfig.opcion6 +
        modulosConfig.opcion7 +
        modulosConfig.opcion8 +
        modulosConfig.opcion9 +
        modulosConfig.opcion10
    );
    setItemAccpersonas(personas);
    setItemAccusertim(usuarios);
    setItemAccuc(contable);
    setItemAccute(ute);
    setItemAccporcenute(porcentaje);
    setItemAccuserweb(userweb);
    setItemAccuserapp(userapp);
    setitemAccestorg(org);

    if (sigue) {
      var user = [];
      var datoPer = [];
      user.push({
        idusuario:
          txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
        login: txtLogin.current.value,
        passwd: txtPassword.current.value,
        persona: txtCedula.current.value,
        status: cmbStatus.current.value,
        idagente: txtIdAgente.current.value,
        accaplicaciones:
          modulos.permodtimbre +
          modulos.permodminas +
          modulos.permod1x500 +
          modulos.permodprod +
          modulos.permodfiscal +
          modulos.permodingresos +
          modulos.permodpresu +
          modulos.permodconfig +
          modulos.rentas +
          modulos.estadal +
          modulos.solvencia +
          modulos.timbreelectronico,
        accconfigene:
          modulosConfig.opcion1 +
          modulosConfig.opcion2 +
          modulosConfig.opcion3 +
          modulosConfig.opcion4 +
          modulosConfig.opcion5 +
          modulosConfig.opcion6 +
          modulosConfig.opcion7 +
          modulosConfig.opcion8 +
          modulosConfig.opcion9 +
          modulosConfig.opcion10,
        accpersonas: personas,
        accusertim: usuarios,
        accuc: contable,
        accute: ute,
        accporcenute: porcentaje,
        accuserweb: userweb,
        accuserapp: userapp,
        accestorg: org,
      });
      datoPer.push({
        apellidos: txtApellidoUsuario.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailUsuario.current.value,
        direccion: txtDireccionUsuario.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreUsuario.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfUsuario.current.value,
        tlf2: txtCelUsuario.current.value,
      });

      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify(user),
        perso: JSON.stringify(datoPer),
      };
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
      setBody(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: mensaje,
        icono: "informacion",
      });
    }
  };

  const onChange = (e) => {
    if (e.target.id === "modulo") {
      setModulosConfig({ ...modulosConfig, [e.target.name]: e.target.value });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setActivate(true);
    procesarRegistro();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
  };

  const checkTodo = (event) => {
    if (event.target.name === "todopersonas") {
      if (chkPerTodo.current.checked) {
        chkPerCon.current.checked = true;
        chkPerIn.current.checked = true;
        chkPerMod.current.checked = true;
        chkPerEli.current.checked = true;
      } else {
        chkPerCon.current.checked = false;
        chkPerIn.current.checked = false;
        chkPerMod.current.checked = false;
        chkPerEli.current.checked = false;
      }
    } else if (event.target.name === "todousuarios") {
      if (chkUsuTodo.current.checked) {
        chkUsuCon.current.checked = true;
        chkUsuIn.current.checked = true;
        chkUsuMod.current.checked = true;
        chkUsuEli.current.checked = true;
      } else {
        chkUsuCon.current.checked = false;
        chkUsuIn.current.checked = false;
        chkUsuMod.current.checked = false;
        chkUsuEli.current.checked = false;
      }
    } else if (event.target.name === "todocontable") {
      if (chkUCTodo.current.checked) {
        chkUCCon.current.checked = true;
        chkUCIn.current.checked = true;
        chkUCMod.current.checked = true;
        chkUCEli.current.checked = true;
      } else {
        chkUCCon.current.checked = false;
        chkUCIn.current.checked = false;
        chkUCMod.current.checked = false;
        chkUCEli.current.checked = false;
      }
    } else if (event.target.name === "todovalorute") {
      if (chkUteTodo.current.checked) {
        chkUteCon.current.checked = true;
        chkUteIn.current.checked = true;
        chkUteMod.current.checked = true;
        chkUteEli.current.checked = true;
      } else {
        chkUteCon.current.checked = false;
        chkUteIn.current.checked = false;
        chkUteMod.current.checked = false;
        chkUteEli.current.checked = false;
      }
    } else if (event.target.name === "todoporcentaje") {
      if (chkPorTodo.current.checked) {
        chkPorCon.current.checked = true;
        chkPorIn.current.checked = true;
        chkPorMod.current.checked = true;
        chkPorEli.current.checked = true;
      } else {
        chkPorCon.current.checked = false;
        chkPorIn.current.checked = false;
        chkPorMod.current.checked = false;
        chkPorEli.current.checked = false;
      }
    } else if (event.target.name === "todouserweb") {
      if (chkUWebTodo.current.checked) {
        /*   chkUWebCon.current.checked = true; */
        chkUWebIn.current.checked = true;
        chkUWebMod.current.checked = true;
        /*    chkUWebEli.current.checked = true; */
      } else {
        chkUWebCon.current.checked = false;
        chkUWebIn.current.checked = false;
        chkUWebMod.current.checked = false;
        chkUWebEli.current.checked = false;
      }
    } else if (event.target.name === "todoapp") {
      if (chkUAppTodo.current.checked) {
        chkUAppCon.current.checked = true;
        chkUAppIn.current.checked = true;
        chkUAppMod.current.checked = true;
        chkUAppEli.current.checked = true;
      } else {
        chkUAppCon.current.checked = false;
        chkUAppIn.current.checked = false;
        chkUAppMod.current.checked = false;
        chkUAppEli.current.checked = false;
      }
    } else if (event.target.name === "todoorg") {
      if (chkOrgTodo.current.checked) {
        chkOrgCon.current.checked = true;
        chkOrgIn.current.checked = true;
        chkOrgMod.current.checked = true;
        chkOrgEli.current.checked = true;
      } else {
        chkOrgCon.current.checked = false;
        chkOrgIn.current.checked = false;
        chkOrgMod.current.checked = false;
        chkOrgEli.current.checked = false;
      }
    }
  };

  const checkBlank = (event) => {
    if (
      chkPerCon.current.checked &&
      chkPerIn.current.checked &&
      chkPerMod.current.checked &&
      chkPerEli.current.checked
    ) {
      chkPerTodo.current.checked = true;
    } else {
      chkPerTodo.current.checked = false;
    }

    if (
      chkUsuCon.current.checked &&
      chkUsuIn.current.checked &&
      chkUsuMod.current.checked &&
      chkUsuEli.current.checked
    ) {
      chkUsuTodo.current.checked = true;
    } else {
      chkUsuTodo.current.checked = false;
    }

    if (
      chkUCCon.current.checked &&
      chkUCIn.current.checked &&
      chkUCMod.current.checked &&
      chkUCEli.current.checked
    ) {
      chkUCTodo.current.checked = true;
    } else {
      chkUCTodo.current.checked = false;
    }

    if (
      chkPorCon.current.checked &&
      chkPorIn.current.checked &&
      chkPorMod.current.checked &&
      chkPorEli.current.checked
    ) {
      chkPorTodo.current.checked = true;
    } else {
      chkPorTodo.current.checked = false;
    }

    if (
      chkUWebIn.current.checked &&
      chkUWebMod.current.checked &&
      chkUWebEli.current.checked
    ) {
      chkUWebTodo.current.checked = true;
    } else {
      chkUWebTodo.current.checked = false;
    }

    if (
      chkUAppCon.current.checked &&
      chkUAppIn.current.checked &&
      chkUAppMod.current.checked &&
      chkUAppEli.current.checked
    ) {
      chkUAppTodo.current.checked = true;
    } else {
      chkUAppTodo.current.checked = false;
    }

    if (
      chkOrgCon.current.checked &&
      chkOrgIn.current.checked &&
      chkOrgMod.current.checked &&
      chkOrgEli.current.checked
    ) {
      chkOrgTodo.current.checked = true;
    } else {
      chkOrgTodo.current.checked = false;
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const principal = () => {
    setOperacion(props.operacion);
    setDeshabilitado(props.deshabilitado);
    if (props.operacion !== 1) {
      setOperacionPer(0);
      setModulos({
        accaplicaciones: props.usuario.accaplicaciones,
        permodtimbre: props.usuario.accaplicaciones.toString().substring(0, 1),
        permodminas: props.usuario.accaplicaciones.toString().substring(1, 2),
        permod1x500: props.usuario.accaplicaciones.toString().substring(2, 3),
        permodprod: props.usuario.accaplicaciones.toString().substring(3, 4),
        permodfiscal: props.usuario.accaplicaciones.toString().substring(4, 5),
        permodingresos: props.usuario.accaplicaciones
          .toString()
          .substring(5, 6),
        permodpresu: props.usuario.accaplicaciones.toString().substring(6, 7),
        permodconfig: props.usuario.accaplicaciones.toString().substring(7, 8),
        rentas: props.usuario.accaplicaciones.toString().substring(8, 9),
        estadal: props.usuario.accaplicaciones.toString().substring(9, 10),
        solvencia: props.usuario.accaplicaciones.toString().substring(10, 11),
        timbreelectronico: props.usuario.accaplicaciones
          .toString()
          .substring(11, 12),
      });
      setModulosConfig({
        opcion1: props.usuario.accconfigene.toString().substring(0, 1),
        opcion2: props.usuario.accconfigene.toString().substring(1, 2),
        opcion3: props.usuario.accconfigene.toString().substring(2, 3),
        opcion4: props.usuario.accconfigene.toString().substring(3, 4),
        opcion5: props.usuario.accconfigene.toString().substring(4, 5),
        opcion6: props.usuario.accconfigene.toString().substring(5, 6),
        opcion7: props.usuario.accconfigene.toString().substring(6, 7),
        opcion8: props.usuario.accconfigene.toString().substring(7, 8),
        opcion9: props.usuario.accconfigene.toString().substring(8, 9),
        opcion10: props.usuario.accconfigene.toString().substring(9, 10),
      });

      setOperacionesMod({
        personas1: props.usuario.accpersonas.toString().substring(0, 1),
        personas2: props.usuario.accpersonas.toString().substring(1, 2),
        personas3: props.usuario.accpersonas.toString().substring(2, 3),
        personas4: props.usuario.accpersonas.toString().substring(3, 4),

        usuarios1: props.usuario.accusertim.toString().substring(0, 1),
        usuarios2: props.usuario.accusertim.toString().substring(1, 2),
        usuarios3: props.usuario.accusertim.toString().substring(2, 3),
        usuarios4: props.usuario.accusertim.toString().substring(3, 4),

        unidadcontable1: props.usuario.accuc.toString().substring(0, 1),
        unidadcontable2: props.usuario.accuc.toString().substring(1, 2),
        unidadcontable3: props.usuario.accuc.toString().substring(2, 3),
        unidadcontable4: props.usuario.accuc.toString().substring(3, 4),

        valorute1: props.usuario.accute.toString().substring(0, 1),
        valorute2: props.usuario.accute.toString().substring(1, 2),
        valorute3: props.usuario.accute.toString().substring(2, 3),
        valorute4: props.usuario.accute.toString().substring(3, 4),

        porcentaje1: props.usuario.accporcenute.toString().substring(0, 1),
        porcentaje2: props.usuario.accporcenute.toString().substring(1, 2),
        porcentaje3: props.usuario.accporcenute.toString().substring(2, 3),
        porcentaje4: props.usuario.accporcenute.toString().substring(3, 4),

        usuarioweb1: props.usuario.accuserweb.toString().substring(0, 1),
        usuarioweb2: props.usuario.accuserweb.toString().substring(1, 2),
        usuarioweb3: props.usuario.accuserweb.toString().substring(2, 3),
        usuarioweb4: props.usuario.accuserweb.toString().substring(3, 4),

        usuarioapp1: props.usuario.accuserapp.toString().substring(0, 1),
        usuarioapp2: props.usuario.accuserapp.toString().substring(1, 2),
        usuarioapp3: props.usuario.accuserapp.toString().substring(2, 3),
        usuarioapp4: props.usuario.accuserapp.toString().substring(3, 4),

        organizacion1: props.usuario.accestorg.toString().substring(0, 1),
        organizacion2: props.usuario.accestorg.toString().substring(1, 2),
        organizacion3: props.usuario.accestorg.toString().substring(2, 3),
        organizacion4: props.usuario.accestorg.toString().substring(3, 4),
      });
    } else {
      setModulos({
        accaplicaciones: "000000000000",
        permodtimbre: "0",
        permodminas: "0",
        permod1x500: "0",
        permodprod: "0",
        permodfiscal: "0",
        permodingresos: "0",
        permodpresu: "0",
        permodconfig: "0",
        estadal: "0",
        rentas: "0",
        solvencia: "0",
        timbreelectronico: "0",
      });
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={principal}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registrar Usuario"
              : operacion === 2
              ? "Modificar Usurario"
              : operacion === 3
              ? "Eliminar Usuario"
              : "Consultar Usuario"}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <CatalogoPersona
          show={mostrar3}
          onHideCancelaCatPer={() => setMostrar3(false)}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />
        <CatalogoAgente
          show={mostrar4}
          onHideCancelaCatAge={() => setMostrar4(false)}
          onHideAceptaCatAge={handleAceptaCatalogoAge}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="">
          <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active "
                style={{ backgroundColor: "#25d366" }}
                id="ex-with-icons-tab-1"
                data-mdb-toggle="tab"
                href="#tab-1"
                role="tab"
                aria-controls="tab-1"
                aria-selected="true"
              >
                <i className="fas fa-user-edit fa-fw me-2"></i>Usuario
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="ex-with-icons-tab-2"
                style={{ backgroundColor: "#55acee" }}
                data-mdb-toggle="tab"
                href="#tab-2"
                role="tab"
                aria-controls="tab-2"
                aria-selected="false"
              >
                <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos
                Aplicaciones
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="ex-with-icons-tab-3"
                style={{ backgroundColor: "rgb(235, 111, 117)" }}
                data-mdb-toggle="tab"
                href="#tab-3"
                role="tab"
                aria-controls="tab-2"
                aria-selected="false"
              >
                <i className="fas fa-vote-yea fa-fw me-2"></i>Permisos
                Configuracion{" "}
              </a>
            </li>
          </ul>
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    <i className="far fa-lg px-1 fa-id-card"></i>Codigo:
                  </label>
                  <input
                    type="text"
                    disabled={true}
                    ref={txtIdUsuario}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={props.usuario ? props.usuario.idusuario : ""}
                    id="inputCodigo"
                    onKeyUp={handleInputChange}
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-5">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    <i className="fas fa-lg px-1 fa-file-signature"></i>Nom.
                    Usuario:
                  </label>
                  <input
                    type="text"
                    autocomplete="off"
                    disabled={operacion === 2 ? true : deshabilitado}
                    ref={txtLogin}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={props.usuario ? props.usuario.login : ""}
                    id="inputLogin"
                    onKeyUp={handleInputChange}
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-3 px-4">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    {" "}
                    Estatus
                  </label>
                  <select
                    ref={cmbStatus}
                    className="form-select"
                    aria-label="Default select example"
                    defaultValue={props.usuario ? props.usuario.status : ""}
                  >
                    <option value="1">Activo</option>
                    <option value="2">Inactivo</option>
                  </select>
                </div>

                <div className="input-group py-1 input-group-sm col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    <i className="fas fa-lg px-1 fa-unlock-alt"></i>Contraseña:
                  </label>
                  <input
                    type={mostrarClave ? "text" : "password"}
                    disabled={operacion === 2 ? true : deshabilitado}
                    ref={txtPassword}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    id="inputPassword"
                    onKeyUp={handleInputChange}
                  />
                  <button
                    style={{ textAlign: "center", color: "white" }}
                    disabled={operacion === 2 ? true : deshabilitado}
                    onClick={() => setMostrarClave(!mostrarClave)}
                    className="btn btn-sm btn-info"
                  >
                    <i className="fa fa-eye-slash"></i>{" "}
                  </button>
                </div>

                <div className="input-group py-1 input-group-sm col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    <i className="fas fa-lg px-1 fa-unlock-alt"></i>Confir.
                    Contr.:
                  </label>
                  <input
                    type={mostrarClave1 ? "text" : "password"}
                    disabled={operacion === 2 ? true : deshabilitado}
                    ref={txtConfirmPassword}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    id="inputConfirmPassword"
                    onKeyUp={handleInputChange}
                  />
                  <button
                    style={{ textAlign: "center", color: "white" }}
                    disabled={operacion === 2 ? true : deshabilitado}
                    onClick={() => setMostrarClave1(!mostrarClave1)}
                    className="btn btn-sm btn-info"
                  >
                    <i className="fa fa-eye-slash"></i>{" "}
                  </button>
                </div>

                <div className="col-md-12 py-1"></div>

                <fieldset className="row border-azul rounded mx-auto">
                  <legend className="float-none m-0 w-auto">Agente</legend>

                  <div className="input-group py-1 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Código
                      Agente:
                    </label>
                    <input
                      type="text"
                      ref={txtIdAgente}
                      autoComplete="off"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputIdAgente"
                      defaultValue={props.usuario ? props.usuario.idagente : ""}
                      onKeyUp={validarAgente}
                      onBlur={validarAgente}
                    />
                    <button
                      onClick={catalogoAge}
                      className="btn btn-sm  btn-success"
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>
                  <div className="input-group py-1 input-group-sm col-sm-8">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="fas fa-lg px-1 fa-file-signature"></i>
                      Nombres:
                    </label>
                    <input
                      type="text"
                      disabled={true}
                      ref={txtNombreAgente}
                      autoComplete="off"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputNomUsuario"
                      defaultValue={
                        props.usuario ? props.usuario.nombreagente.trim() : ""
                      }
                    />
                  </div>
                </fieldset>

                <div className="col-md-12 py-1"></div>

                <fieldset className="row border-azul rounded mx-auto">
                  <legend className="float-none m-0 w-auto">
                    Datos Personales del Usuario
                  </legend>

                  <div className="container col-md-12 row m-0">
                    <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-id-card"></i>Cedula:
                      </label>
                      <input
                        type="text"
                        ref={txtCedula}
                        autoComplete="off"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputCedula"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.cedula
                            : ""
                        }
                        onKeyUp={validarPersona}
                        onBlur={validarPersona}
                      />
                      <button
                        onClick={catalogoPer}
                        className="btn btn-sm  btn-success"
                      >
                        <i className="fa fa-search"></i>{" "}
                      </button>
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-3 mx-auto px-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-map-marked-alt"></i>
                        Nacionalidad:
                      </label>
                      <select
                        disabled={!habilitadoNU}
                        ref={cmbNacionalidad}
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.nacionalidad
                            : ""
                        }
                        className="form-select"
                        aria-label="Default select example col-md-"
                      >
                        <option key="0" value="V">
                          V
                        </option>
                        <option key="1" value="E">
                          E
                        </option>
                      </select>
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-2 ml-auto px-1">
                      <label
                        className="input-group-text ml-2"
                        id="inputGroup-sizing-sm"
                      >
                        Sexo:
                      </label>
                      <select
                        disabled={!habilitadoNU}
                        ref={cmbSexo}
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.sexo
                            : ""
                        }
                        className="form-select"
                        aria-label="Default select example"
                      >
                        <option key="0" value="M">
                          M
                        </option>
                        <option key="1" value="F">
                          F
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="container col-md-12 row m-0">
                    <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Nombres:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtNombreUsuario}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNomUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.nombres.trim()
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-6 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        apellidos:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtApellidoUsuario}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputApeUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.apellidos.trim()
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-file-signature"></i>
                        Direccion:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtDireccionUsuario}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputApeUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.direccion.trim()
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="container col-md-12 row m-0">
                    <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="far fa-lg px-1 fa-calendar-alt"></i>Fecha
                        Nacimiento:
                      </label>
                      <input
                        type="date"
                        disabled={!habilitadoNU}
                        ref={txtFechaNac}
                        className="form-control px-0"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputFechaNac"
                        max={moment(fechaSistema).format("YYYY-MM-DD")}
                        defaultValue={
                          props.datospersonales
                            ? moment(props.datospersonales.fnacimiento).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                        }
                        onKeyUp={handleInputChange}
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-4">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-phone"></i>Telefono:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtTlfUsuario}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputTlfUsuario"
                        placeholder="0000-0000000"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.tlf1 !== null
                              ? props.datospersonales.tlf1.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-4 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        <i className="fas fa-lg px-1 fa-mobile-alt"></i>Celular:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtCelUsuario}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputCelUsuario"
                        placeholder="0000-0000000"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.tlf2 !== null
                              ? props.datospersonales.tlf2.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="container col-md-12 row m-0">
                    <div className="input-group py-1 input-group-sm col-sm-12 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        {" "}
                        <i className="fas fa-lg px-1 fa-at"></i>E-mail:
                      </label>
                      <input
                        type="text"
                        disabled={!habilitadoNU}
                        autoComplete="off"
                        ref={txtEmailUsuario}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputEmailUsuario"
                        defaultValue={
                          props.datospersonales
                            ? props.datospersonales.correoe !== null
                              ? props.datospersonales.correoe.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="tab-2"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-2"
            >
              <div className="container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto">
                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Timbres Fiscales
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodtimbre"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permodtimbre === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodtimbre"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permodtimbre === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Impuesto de Producción
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodminas"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permodminas === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodminas"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permodminas === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Impuesto de Minas
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permod1x500"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permod1x500 === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permod1x500"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permod1x500 === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Impuesto 1x1000
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodprod"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permodprod === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodprod"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permodprod === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Rentas Inmobiliarias
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="rentas"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.rentas === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="rentas"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.rentas === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Reg. Estadal Tributario
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="estadal"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.estadal === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="estadal"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.estadal === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Timbre Electronico
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="timbreelectronico"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.timbreelectronico === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="timbreelectronico"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.timbreelectronico === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Solvencia
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="solvencia"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.solvencia === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="solvencia"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.solvencia === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Fiscalización
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodfiscal"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permodfiscal === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodfiscal"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permodfiscal === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Gestión de Ingresos
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodingresos"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permodingresos === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodingresos"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permodingresos === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Presupuesto
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodpresu"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permodpresu === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodpresu"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permodpresu === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Configuración
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodconfig"
                          id="inlineRadio1"
                          value={true}
                          checked={modulos.permodconfig === "1"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="permodconfig"
                          id="inlineRadio2"
                          value={false}
                          checked={modulos.permodconfig === "0"}
                          onChange={handleChangeOtro}
                        />
                        <label className="form-check-label" for="inlineRadio2">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="tab-3"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-3"
            >
              <div className="row mx-auto">
                {/* Organización */}
                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Organización
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion1"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion1 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion1"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion1 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                {/* Personas */}
                <div className="col-md-12 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Personas
                    </legend>
                    <div className="col-md-2 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion2"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion2 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion2"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion2 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                    {modulosConfig.opcion2 === "1" && (
                      <div className="col-md-8 row mb-3 rounded">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPerCon}
                              defaultChecked={
                                operacionesMod.personas1 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPerIn}
                              defaultChecked={
                                operacionesMod.personas2 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPerMod}
                              defaultChecked={
                                operacionesMod.personas3 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPerEli}
                              defaultChecked={
                                operacionesMod.personas4 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              name="todopersonas"
                              ref={chkPerTodo}
                              defaultChecked={
                                operacionesMod.personas1 === "1" &&
                                operacionesMod.personas2 === "1" &&
                                operacionesMod.personas3 === "1" &&
                                operacionesMod.personas4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>

                {/* Usuarios */}
                <div className="col-md-12 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Usuarios
                    </legend>
                    <div className="col-md-2 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion3"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion3 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion3"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion3 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                    {modulosConfig.opcion3 === "1" && (
                      <div className="col-md-8 row mb-3 rounded">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUsuCon}
                              defaultChecked={
                                operacionesMod.usuarios1 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUsuIn}
                              defaultChecked={
                                operacionesMod.usuarios2 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUsuMod}
                              defaultChecked={
                                operacionesMod.usuarios3 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUsuEli}
                              defaultChecked={
                                operacionesMod.usuarios4 === "1" ? true : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="todousuarios"
                              id="flexCheckDefault"
                              ref={chkUsuTodo}
                              defaultChecked={
                                operacionesMod.usuarios1 === "1" &&
                                operacionesMod.usuarios2 === "1" &&
                                operacionesMod.usuarios3 === "1" &&
                                operacionesMod.usuarios4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>

                {/* Unidad Contable */}
                <div className="col-md-12 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Unidad Contable
                    </legend>
                    <div className="col-md-2 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion4"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion4 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion4"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion4 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                    {modulosConfig.opcion4 === "1" && (
                      <div className="col-md-8 row mb-3 rounded">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUCCon}
                              defaultChecked={
                                operacionesMod.unidadcontable1 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUCIn}
                              defaultChecked={
                                operacionesMod.unidadcontable2 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUCMod}
                              defaultChecked={
                                operacionesMod.unidadcontable3 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUCEli}
                              defaultChecked={
                                operacionesMod.unidadcontable4 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="todocontable"
                              id="flexCheckDefault"
                              ref={chkUCTodo}
                              defaultChecked={
                                operacionesMod.unidadcontable1 === "1" &&
                                operacionesMod.unidadcontable2 === "1" &&
                                operacionesMod.unidadcontable3 === "1" &&
                                operacionesMod.unidadcontable4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>

                {/* Valor Ute */}
                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Valor UTE
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion5"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion5 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion5"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion5 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-md-6"></div>

                {/* Porcentaje Ute */}
                <div className="col-md-12 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Porcentaje UTE
                    </legend>
                    <div className="col-md-2 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion6"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion6 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion6"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion6 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                    {modulosConfig.opcion6 === "1" && (
                      <div className="col-md-8 row mb-3 rounded">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPorCon}
                              defaultChecked={
                                operacionesMod.porcentaje1 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPorIn}
                              defaultChecked={
                                operacionesMod.porcentaje2 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPorMod}
                              defaultChecked={
                                operacionesMod.porcentaje3 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkPorEli}
                              defaultChecked={
                                operacionesMod.porcentaje4 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="todoporcentaje"
                              id="flexCheckDefault"
                              ref={chkPorTodo}
                              defaultChecked={
                                operacionesMod.porcentaje1 === "1" &&
                                operacionesMod.porcentaje2 === "1" &&
                                operacionesMod.porcentaje3 === "1" &&
                                operacionesMod.porcentaje4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>

                {/* Usuario Web */}
                <div className="col-md-12 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      G. Usuario Web
                    </legend>
                    <div className="col-md-2 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion7"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion7 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion7"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion7 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                    {modulosConfig.opcion7 === "1" && (
                      <div className="col-md-8 row mb-3 rounded">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUWebCon}
                              defaultChecked={
                                operacionesMod.usuarioweb1 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUWebIn}
                              defaultChecked={
                                operacionesMod.usuarioweb2 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUWebMod}
                              defaultChecked={
                                operacionesMod.usuarioweb3 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUWebEli}
                              defaultChecked={
                                operacionesMod.usuarioweb4 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="todouserweb"
                              id="flexCheckDefault"
                              ref={chkUWebTodo}
                              defaultChecked={
                                operacionesMod.usuarioweb1 === "1" &&
                                operacionesMod.usuarioweb2 === "1" &&
                                operacionesMod.usuarioweb3 === "1" &&
                                operacionesMod.usuarioweb4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>

                {/* Usuario App */}
                <div className="col-md-12 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      G. Usuario App
                    </legend>
                    <div className="col-md-2 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion8"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion8 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion8"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion8 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                    {modulosConfig.opcion8 === "1" && (
                      <div className="col-md-8 row mb-3 rounded">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUAppCon}
                              defaultChecked={
                                operacionesMod.usuarioapp1 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUAppIn}
                              defaultChecked={
                                operacionesMod.usuarioapp2 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUAppMod}
                              defaultChecked={
                                operacionesMod.usuarioapp3 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkUAppEli}
                              defaultChecked={
                                operacionesMod.usuarioapp4 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="todoapp"
                              id="flexCheckDefault"
                              ref={chkUAppTodo}
                              defaultChecked={
                                operacionesMod.usuarioapp1 === "1" &&
                                operacionesMod.usuarioapp2 === "1" &&
                                operacionesMod.usuarioapp3 === "1" &&
                                operacionesMod.usuarioapp4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>

                {/* Estructura Organizativa */}
                <div className="col-md-12 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Estructura Organizativa
                    </legend>
                    <div className="col-md-2 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion9"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion9 === "1" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion9"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={modulosConfig.opcion9 === "0" ? true : false}
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                    {modulosConfig.opcion9 === "1" && (
                      <div className="col-md-8 row mb-3 rounded">
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkOrgCon}
                              defaultChecked={
                                operacionesMod.organizacion1 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Consultar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkOrgIn}
                              defaultChecked={
                                operacionesMod.organizacion2 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Incluir
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkOrgMod}
                              defaultChecked={
                                operacionesMod.organizacion3 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Modificar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              id="flexCheckDefault"
                              onChange={checkBlank}
                              ref={chkOrgEli}
                              defaultChecked={
                                operacionesMod.organizacion4 === "1"
                                  ? true
                                  : false
                              }
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Eliminar
                            </label>
                          </div>
                        </div>
                        <div className="col d-flex justify-content-center">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              disabled={
                                operacion === 1 || operacion === 2
                                  ? false
                                  : true
                              }
                              type="checkbox"
                              value="1"
                              name="todoorg"
                              id="flexCheckDefault"
                              ref={chkOrgTodo}
                              defaultChecked={
                                operacionesMod.organizacion1 === "1" &&
                                operacionesMod.organizacion2 === "1" &&
                                operacionesMod.organizacion3 === "1" &&
                                operacionesMod.organizacion4 === "1"
                                  ? true
                                  : false
                              }
                              onChange={checkTodo}
                            />
                            <label
                              className="form-check-label py-1"
                              for="flexCheckDefault"
                            >
                              Todo
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                  </fieldset>
                </div>

                {/* Ejercicio Fiscal */}
                <div className="col-md-6 row mx-auto mb-1">
                  <fieldset className=" row col-sm-12 mx-auto border-azul rounded py-0">
                    <legend
                      className="float-none fw-bold w-auto"
                      style={{ fontSize: "15px" }}
                    >
                      Cambiar Ejercicio Fiscal
                    </legend>
                    <div className="col-md-6 pl-3 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion10"
                          value={"1"}
                          id="modulo"
                          onChange={onChange}
                          checked={
                            modulosConfig.opcion10 === "1" ? true : false
                          }
                        />
                        <label className="form-check-label py-1">
                          Disponible
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="radio"
                          name="opcion10"
                          value={"0"}
                          id="modulo"
                          onChange={onChange}
                          checked={
                            modulosConfig.opcion10 === "0" ? true : false
                          }
                        />
                        <label className="form-check-label py-1">
                          No Disponible
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-6"></div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-sm-12 d-flex justify-content-end row mx-auto py-1">
          <button
            type="button"
            ref={btnAcepta}
            disabled={operacion === 4 ? true : false}
            onClick={onChangeValidar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-success rounded-pill"
          >
            <i className="far fa-check-circle"></i>Aceptar
          </button>
          <button
            type="button"
            ref={btnCancela}
            onClick={cancelar}
            style={{ margin: "1px" }}
            className="col-sm-2 btn-sm btn btn-danger rounded-pill"
          >
            <i className="fas fa-window-close"></i>Cancelar
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ModalActualizarUsuario;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalActualizarUsuario.js